import { connect } from 'react-redux';
import {actions} from '../../../../../redux/modules/Devolucion/devolucion';
import DevolucionGrid from './DevolucionGrid';

const mstp = state => {
    return {
        ...state.devolucion,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(DevolucionGrid)
